// eslint-disable-next-line no-unused-vars
import { post, get } from '../axios'

const api = `${process.env.VUE_APP_COL}`
// const api = 'https://bff-shopify-develop.kapeixi.cn/admin'

// 分页查询置顶商品组
export function admin_col_top_page(map, option) {
  return post(`${api}/col/top/page`, map, option)
}
// 保存商品组
export function admin_col_top_save(map, option) {
  return post(`${api}/col/top/save`, map, option)
}
// 校验skc，批量接口
export function admin_col_top_check_skc(map, option) {
  return post(`${api}/col/top/check`, map, option)
}
// 删除商品组
export function admin_col_top_delete(map, option) {
  return get(`${api}/col/top/delete/${map.id}`, option)
}
// 查询商品组详情
export function admin_col_top_get_detail(map, option) {
  return get(`${api}/col/top/detail/${map.id}`, map, option)
}
// 复制collection
export function admin_col_copy(map, option) {
  return get(`${api}/col/copy/${map.id}`, option)
}
